module.exports = __webpack_public_path__ + "static/swim-a92e2cf8ec43da7cf2d6d181cd669a6b.jpg";